import { useTranslation } from 'react-i18next';
import { EMAIL_NS } from '@/Domain/components/Integration/Email/email.const';

/** Pill marking a field the integration works without. */
export const OptionalBadge = ({ 'data-testid': testId }: { 'data-testid'?: string }) => {
  const { t } = useTranslation('integration');

  return (
    <span
      className="rounded-full bg-muted px-2 py-0.5 text-xs font-medium text-muted-foreground"
      data-testid={testId}
    >
      {t(`${EMAIL_NS}.optional`)}
    </span>
  );
};

export default OptionalBadge;
